// The unified share endpoints return ONE mixed list, each item tagged with
// `type` ('file' | 'folder') and carrying its node payload. Tag with a stable
// React key for the grids. Shared by the Shared view and the My Docs overlay.
export const tagShareItems = (shares = []) => shares.map((s, i) => ({
  kind: s.type,
  key: `${s.type}-${s.node?.uuid ?? s.shareUuid ?? i}`,
  data: s,
}));
